<!--
 * @Author: guojia 66291979@qq.com
 * @Date: 2024-05-10 01:31:08
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-03-11 16:11:41
 * @FilePath: /lobby/src/views/HomeView.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div class="home" id="scrollableDiv" v-if="hasCid || country != 'ET'">
    <!-- <div id='lottie' style="position: absolute;z-index: 999;" /> -->
    <div
      :class="`banner-content ${hasStickyBanner ? (checkShowAPPDownloadBanner ? 'padding-top_2' : 'padding-top_1') : checkShowAPPDownloadBanner ? 'padding-top_2' : 'padding-top_0'}`"
      :key="bannerKey"
    >
      <van-swipe :touchable="true" class="banners" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          @click="onClickBanner(banner)"
          v-for="(banner, i) in isLogin ? bannersHomeTop : nologinbanners"
          :key="i"
        >
          <img :src="banner.cover" class="img" :alt="banner.name" />
          <!-- <div class="join-now-btn" v-if="!isLogin">Join Now</div> -->
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="rewards_enter">
      <!-- <div class="rewards_enter" v-if="country == 'ET' || country == 'KE'"> -->
      <!-- <div class="on_left" @click="onShowRewardsCenter(1)">
        <img :src="`${resBaseUrl}spinner_enter_01_en.png`" width="50%" />
        <div v-if="showLuckywheelTips" class="tag">New Rewards</div>
      </div>
      <div class="on_right" @click="onShowRewardsCenter(0)">
        <img v-if="country == 'KE'" :src="`${resBaseUrl}index-gn02-1129.png`" width="50%" />
        <img v-if="country == 'ET'" :src="`${resBaseUrl}index-gn02.png`" width="50%" />
        <div v-if="country == 'ET'" class="tag" :style="`background-color: ${envelopColor};`">
          {{ formatMoney(envelopValue) }}
          {{ balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias() }}
        </div>
      </div> -->
      <div
        v-for="(banner, index) in frontTooth"
        :class="index % 2 == 0 ? 'on_left' : 'on_right'"
        :key="index"
        @click="onClickBanner(banner)"
      >
        <img :src="banner.cover" width="50%" />
        <div
          v-if="showLuckywheelTips && ['luckywheel', 'dailytask'].includes(banner.cmdValue)"
          class="tag"
        >
          New Rewards
        </div>
        <div
          v-if="banner.cmd == 'active' && banner.cmdValue == 'redenvelope'"
          class="tag"
          :style="`background-color: ${envelopColor};`"
        >
          {{ formatMoney(envelopValue) }}
          {{ balance && balance.currencyAlias ? balance.currencyAlias : defaultCurrencyAlias() }}
        </div>
      </div>
      <div v-if="frontTooth.length % 2 > 0" class="on_right"></div>
    </div>
    <div style="height: 0.4rem"></div>
    <!-- 跑马灯 -->
    <DhMarquee />
    <!-- 功能栏 -->
    <DhNavTab v-if="from == '' && (navtabType == gameType || country != 'ET')" />
    <nav-tab-sport v-else-if="navtabType == sportType" />
    <div v-if="navtabType == sportType && country == 'ET'" class="sport-iframe">
      <iframe
        :src="sportPageUrl"
        frameborder="0"
        v-if="sportPageUrl.length > 0"
        width="100%"
        height="100%"
      ></iframe>
    </div>
    <div v-else-if="functionTabIndex == 0 && from == ''">
      <div v-for="(tab, index) in recommend" :key="index">
        <div v-if="tab.style == 'grid' && tab.rows == 2">
          <DhGridGames :funTab="tab" class="content" />
          <div class="index_banner" v-if="tab.haveDownBanner">
            <DhLazyBanner :name="tab.name" />
          </div>
        </div>
        <div v-if="tab.style == 'grid' && tab.rows > 2">
          <DhGridListGames :funTab="tab" class="content" :isHome="true" />
          <div class="index_banner" v-if="tab.haveDownBanner">
            <DhLazyBanner :name="tab.name" />
          </div>
        </div>
        <div v-if="tab.style == 'list'">
          <DhListGames :funTab="tab" class="content" :isHome="true" />
          <div class="index_banner" v-if="tab.haveDownBanner">
            <DhLazyBanner :name="tab.name" />
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="from == ''">
      <!-- <div
        v-if="
          functionTabs[functionTabIndex - 1].style == 'grid' &&
          functionTabs[functionTabIndex - 1].rows == 2
        "
      >
        <DhGridGames :funTab="functionTabs[functionTabIndex - 1]" class="content" />
        <div class="index_banner" v-if="functionTabs[functionTabIndex - 1].haveDownBanner">
          <DhLazyBanner :name="functionTabs[functionTabIndex - 1].name" />
        </div>
      </div> -->
      <div
        :key="gameListKey"
        v-if="
          functionTabs[functionTabIndex - 1].style == 'grid' &&
          functionTabs[functionTabIndex - 1].rows >= 2
        "
      >
        <DhGridListGames
          :showTitle="false"
          :funTab="functionTabs[functionTabIndex - 1]"
          class="content"
        />
        <div class="index_banner" v-if="functionTabs[functionTabIndex - 1].haveDownBanner">
          <DhLazyBanner :name="functionTabs[functionTabIndex - 1].name" />
        </div>
      </div>
      <div :key="gameListKey" v-if="functionTabs[functionTabIndex - 1].style == 'list'">
        <DhListGames
          :showTitle="false"
          :funTab="functionTabs[functionTabIndex - 1]"
          class="content"
        />
        <div class="index_banner" v-if="functionTabs[functionTabIndex - 1].haveDownBanner">
          <DhLazyBanner :name="functionTabs[functionTabIndex - 1].name" />
        </div>
      </div>
    </div>
    <DhFootContent v-if="from == '' && (navtabType == gameType || country != 'ET')" />
    <div style="height: 0.5rem" v-if="navtabType == gameType || country != 'ET'" />
    <HelpComponents v-if="navtabType == gameType || country != 'ET'" />
    <div style="height: 1.5rem" v-if="navtabType == gameType || country != 'ET'" />
  </div>
  <div v-else-if="isLogin" class="home" id="scrollableDiv">
    <game-view :from="from" :hasCid="hasCid" />
  </div>
  <SportLogin v-else :from="from" :hasCid="hasCid" />
</template>

<script>
import DhLazyBanner from '@/components/DhLazyBanner.vue'
import DhFootContent from '@/components/FootContent.vue'
import DhGridGames from '@/components/GridGames.vue'
import DhGridListGames from '@/components/GridListGames.vue'
import HelpComponents from '@/components/HelpComponents.vue'
import DhListGames from '@/components/ListGames.vue'
import DhMarquee from '@/components/Marquee.vue'
import DhNavTab from '@/components/NavTab.vue'
import GameView from '@/views/GameView.vue'
import SportLogin from '@/views/SportLogin.vue'
import NavTabSport from '@/components/NavTabSport.vue'

import { config } from '@/common/config'
import { getLocalStorage, Key } from '@/common/localStorage'
import { BUS, POPUP } from '@/event/EventCenter'
import { useEnvelopeStore } from '@/stores/envelope'
import { GAME_NAV_TAB_TYPE, SPORT_NAV_TAB_TYPE, useLobbyStore } from '@/stores/lobby.js'
import { useSystemStore } from '@/stores/system.js'
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user.js'
import {
  currentPage,
  defaultCurrencyAlias,
  encodeBase64,
  enterEnvelop,
  ENV,
  formatMoney,
  setSEO
} from '@/utils/helper'
import { useDailyTaskStore } from '@/stores/dailyTask'

export default {
  components: {
    DhMarquee,
    DhNavTab,
    DhGridGames,
    DhListGames,
    DhFootContent,
    DhGridListGames,
    DhLazyBanner,
    HelpComponents,
    GameView,
    SportLogin,
    NavTabSport
  },
  props: {
    from: {
      type: String,
      default: ''
    },
    hasCid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(useLobbyStore, [
      'bannersHomeTop',
      'recommend',
      'functionTabIndex',
      'functionTabs',
      'hasStickyBanner',
      'checkShowAPPDownloadBanner',
      'navtabType'
    ]),
    ...mapState(useUserStore, ['isLogin', 'country', 'balance'])
  },
  watch: {
    hasStickyBanner(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.bannerKey++
      }
    },
    isLogin(newvalue, oldvalue) {
      if (newvalue != oldvalue) {
        this.checkEnvelop()
      }
    }
  },
  data() {
    return {
      resBaseUrl: config.resBaseUrl,
      gameListKey: 0,
      bannerKey: 0,
      showLuckywheelTips: false,
      envelopValue: '----',
      envelopColor: '#a40035',
      version: __APP_VERSION__,
      frontTooth: [],
      nologinbanners: [
        {
          cover: config.resBaseUrl + 'index_lb_WELCOME_1.jpg',
          name: '',
          cmd: 'no_login_banner',
          cmdValue: 'firstRecharge'
        }
      ],
      sportType: SPORT_NAV_TAB_TYPE,
      gameType: GAME_NAV_TAB_TYPE,
      sportPageUrl: ''
    }
  },
  mounted() {
    this.ping()
    this.$bus.$emit(BUS.SHOW_SYSTEM_LOADING, true)
    this.updateUserInfo().finally(() => {
      this.updateLobby().finally(() => {
        this.bannerKey++
        this.$bus.$emit(BUS.SHOW_SYSTEM_LOADING, false)
      })
    })
    this.$bus.$on(BUS.SCROLL_TO_TOP, () => {
      var scrollableDiv = document.getElementById('scrollableDiv')
      scrollableDiv && (scrollableDiv.scrollTop = 0)
    })
    this.$bus.$on(BUS.UPDATE_GAME_LIST, () => {
      this.gameListKey++
      var scrollableDiv = document.getElementById('scrollableDiv')
      scrollableDiv && (scrollableDiv.scrollTop = 0)
    })
    this.$bus.$on(BUS.CHANGE_SPROT_NAV_TAB, (item) => {
      if (this.isLogin) {
        const env = import.meta.env.VITE_APP_ENV
        const gameconfig = {
          staging: {
            ET: 10191,
            CI: 10197,
            KE: 30001, //30025
            TZ: 50040
          },
          app_staging: {
            ET: 10191,
            CI: 10197,
            KE: 30001, //30025
            TZ: 50040
          },
          production: {
            ET: 10021,
            CI: 20021,
            KE: 30001, //30004
            TZ: 50040,
            GH: 40040
          },
          app: {
            ET: 10021,
            CI: 20021,
            KE: 30001, //30004
            TZ: 50040
          }
        }
        let gameId = parseInt(gameconfig[env][this.country])
        this.enterGame(gameId).then((response) => {
          // this.currentGameUrl = response.url
          // this.showFooter = true
          // this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          this.sportPageUrl = response.url
        })
      } else {
        // let setIframePath = ['', '', '','','live', 'football', 'basketball'][item.id]
        // fetch('https://api-ms.crashgame247.io/game-session', {
        //   headers: {
        //     accept: 'application/json, text/plain, */*',
        //     'accept-language': 'zh-CN,zh;q=0.9',
        //     'content-type': 'application/json',
        //     priority: 'u=1, i',
        //     'sec-ch-ua': '"Google Chrome";v="135", "Not-A.Brand";v="8", "Chromium";v="135"',
        //     'sec-ch-ua-mobile': '?1',
        //     'sec-ch-ua-platform': '"Android"',
        //     'sec-fetch-dest': 'empty',
        //     'sec-fetch-mode': 'cors',
        //     'sec-fetch-site': 'cross-site',
        //     'x-device': 'WEB',
        //     'x-lang': 'en',
        //     'x-platform': 'unknown'
        //   },
        //   referrer: `https://${window.hostname}/`,
        //   referrerPolicy: 'strict-origin-when-cross-origin',
        //   body: JSON.stringify({
        //     currency: 'USD',
        //     gameCode: 'btsg_sportbetting',
        //     meta: { allowParentUrlUpdate: true, extra_url_params: { setIframePath } }
        //   }),
        //   method: 'POST',
        //   mode: 'cors',
        //   credentials: 'omit'
        // }).then((r) => {
        //   console.log('r', r)
        //   this.sportPageUrl = r.url
        // }) //
        // let setIframePath = null
        this.sportPageUrl =
          'https://launcher-eu1.fh8labs.com/games/encrypted/launcher?payload=QTEyOEdDTQ.OTycnuE7m_4KuvN9EXFmRi5MF8KY3IiLZAv7SxL9e7UI9eyZTw7knAncOd8.rwIS2EKJLgNhax6M.dz5LeERr5mR_v79dG5P1aTmxj0xyVZ_dpMFxEv5g5xUJ4F--KInKbm37bdtyWQ7vEbvVCmqp8Z3xM4OVDbUIeIS4UpsCKEnNtsVTcq_3oNTp1hfYVs8D90ufn4HErp7bd9ZmIc78qJk-Hd8bdBVGP34JtBsnojeN8OQTFEEEmJMBb_7AemE2cuy6rociFHPfYSOiH46ob4-jU0K-D2Ll3Oy4qZWy8XG60G4pSUZkmPDrnVWk2ESRLSrlyLDt8bvaX57xm4NpsGiDWxgf7sAxrLAJNGzFnecrG60EQ3x-NmYcip8X3wVkWH2XKsDRqu2iaTRVdykNWUcLraMimez7v2qnxhHH37c9MNwHHE9MwF85nnygqhflz2Jz4pAHeho01W6FaPY_07mhEqonvuPTIGgzjfT1i0HeXO7SuKJhz5J4sGamkvXi92UJwcvCSCEnRWfmqyo-F4XPdQJtyChT65w_l_Ww9DyMbt0Qj8V7za18WR1sNKQZUr0h5a0QhcN3tlP8OOAbB1Xb0AGaHjcPqYrYa17LSQ20J2EAafdP.J5X2f1C0IUn8stfAfqvjow&setIframePath='
        console.log('item', item)
        if (item.id == 1) {
          // home
          this.sportPageUrl =
            'https://launcher-eu1.fh8labs.com/games/encrypted/launcher?payload=QTEyOEdDTQ.OTycnuE7m_4KuvN9EXFmRi5MF8KY3IiLZAv7SxL9e7UI9eyZTw7knAncOd8.rwIS2EKJLgNhax6M.dz5LeERr5mR_v79dG5P1aTmxj0xyVZ_dpMFxEv5g5xUJ4F--KInKbm37bdtyWQ7vEbvVCmqp8Z3xM4OVDbUIeIS4UpsCKEnNtsVTcq_3oNTp1hfYVs8D90ufn4HErp7bd9ZmIc78qJk-Hd8bdBVGP34JtBsnojeN8OQTFEEEmJMBb_7AemE2cuy6rociFHPfYSOiH46ob4-jU0K-D2Ll3Oy4qZWy8XG60G4pSUZkmPDrnVWk2ESRLSrlyLDt8bvaX57xm4NpsGiDWxgf7sAxrLAJNGzFnecrG60EQ3x-NmYcip8X3wVkWH2XKsDRqu2iaTRVdykNWUcLraMimez7v2qnxhHH37c9MNwHHE9MwF85nnygqhflz2Jz4pAHeho01W6FaPY_07mhEqonvuPTIGgzjfT1i0HeXO7SuKJhz5J4sGamkvXi92UJwcvCSCEnRWfmqyo-F4XPdQJtyChT65w_l_Ww9DyMbt0Qj8V7za18WR1sNKQZUr0h5a0QhcN3tlP8OOAbB1Xb0AGaHjcPqYrYa17LSQ20J2EAafdP.J5X2f1C0IUn8stfAfqvjow&setIframePath='
        }
        if (item.id == 4) {
          // live
          this.sportPageUrl =
            'https://launcher-eu1.fh8labs.com/games/encrypted/launcher?payload=QTEyOEdDTQ.QGGHgQz8e4UfGPGKQ4sYoIjH8OD6HKrhWFBr6JmCgIZheCjUzJHuu6cW_JY.5QY0eK2b-60nVYIu.x_aIA9Fns_zoBc-lthP7EsTthTsxNvC35EKduSkWlj3b8u3a-f_xGvImaN62TI7LKC4RLs6B7Qr8nzM4GECRM5WFFWNwxAPwmKo5tf9ku1no22QVeiZUJgcKGFJuVixafxM5LXU1AOkh-XOSvmAlFUSH9GAtk_rrUCPTgItNYA_ohWUFwpZ3IX27hOw0nVvE7y74hEfuhKur2y73KaUc0eYd6D1rwOP-1SB7L7pt3DW7i6UrbSHgc22i7R6Ap9Srnw2n-dCn5dOPjKmrD3LSn8AaIAzDRVjyumFv9gPB_lKJKP5u7n2xz_YS2vkfF10eweImWndrBn3jcEWbS8LwXPpq419eApeZfV_9aoTQhTYNj0WiUoPvC0qzMEdXmQjfu7X792B5vVxQpImoTLzJ2_2XNuod4qDC2x-Loa2oGlDxJL0jgLFmKCfBJZvqMCt1nzus8CcA3rsPs_rkXSaRqUBPNpDxLRXszNJ8WJH5iQWHrx4Pe_Phqr0G8aBNrNwnKFP8EuDkan0I8vRyC3B48Tnx40LWLtCopeu_oEH_pYDLsQ.AheKCVmhD9gNgOdAxZ7H8A&setIframePath=live'
        } else if (item.id == 5) {
          // football
          this.sportPageUrl =
            'https://launcher-eu1.fh8labs.com/games/encrypted/launcher?payload=QTEyOEdDTQ.e8AlrXvwpefUGaOvLilnj_hKm4-O5Z4unQ1ifuk0-77khBmECazY2FiH0CU.FDxR4pU8qxz4GrBs._0g07rg8TBrK5WpoFxeVDoD2RcwaeXs2A-N8Sv-qlifKusLnz_ZfqEQE0Y73ZokmxfmE52YEHmikrCBnufPxULprUX9nIB_0KKNe9b9jHOyjXFFL7nBEwmIQ7jlo_bvymtnkVc_TpIfsSIBl0JQHNwOHgv-KtOk5pVFW93bK0sTsWmlySUIWxGQ2ALF0s0cET8DzRnjA-VW22D7FtlQGBIN4K7fqCs7Ao1uTVObg73-BKfPaGqskoLDVMg141XuvQwODsA432O74oAduD1VnOuQ7_DH-NZhPRvW1JFxpBUSZ-CeR_cBjgzFcUSF5OPJL9pe4LvFejewh4LMtDMmLrQB-bW0RAYA3Nfd1ubdc_bc_yGqP0barr2TbOpuazjG7OqEi05GfAOsO6VoxQjZf2efbJ8bP1iOIcrDM2FvVOn0bDj7ufjzKgbOSQN8K7ovXbktXo1K3R7bVcN4KWT_1mHvY6XTqP33lURF1DF_ixCs2SvWSXwtZYrtWl4siuOjMjLX-yz3AP3l39dYFKWDdl69i5n4AReho9f3_c3qgpzv6215S-qM.MU2h7uQHf4evLmxNiqTLCA&setIframePath=football'
        } else if (item.id == 6) {
          // basketball
          this.sportPageUrl =
            'https://launcher-eu1.fh8labs.com/games/encrypted/launcher?payload=QTEyOEdDTQ.2llHpyhpc777wf9QoV-1rWKjpQSFRgXioSqvCpiAX1gIgGqTjtT1HmTrdcU.lMy4J7kIaJxgeQvR.7-RIoQXKrIM-7x55eRFTtX8-Ct8asDbq12Ubd8P81LU5RfyO8MMNhdypDr-Az3lBePGwSHk2xqXAmxbtruGUBjAojviYzYZHNcA0FdW1HxAAJZaPsdON5bUcy7r9ZGst85EndDpAW5b-lG1oebjmWgNNAJvVnS_uFTCDpE6b5JWGctRTJhX3rZiy7QkRyj83UoCCvTqbpIJgcwT0dMTOuHQwUtQL4igkHgfKBZp6pk_YDeI62vm0uqlG7NJ7Peu-0l3rku9leDAlsQw9chhZL-qpBOY0a_Z4NltcceZ4dm_dyldjVUA5rVB2j2LZpD6kFRohGGunZcsjdyGrKeg8TBQJb08OBTkxDpmKGu4rULVTW9BA0X9_1f2pMFbkKoEv0xFYyrN2wGKu0gTPqLu21mVXGiXTYD9LzERpRFJSm2MCeDYDsC2Gtd9xaJb-WDIHchEio6DEF94rYrtGX8ytbiBJKf89SsKBcjGJKAOnSri8_bZBlr3KMNlkrpouyDh1c0bCUP-ECPUUeqlYaOG7YScIWTlnAJ5ynEPOs3EFL23veq0kEdyzkg.AJVL4hU0jSjXFXAN4CIsCA&setIframePath=basketball'
        }
      }
    })
    var scrollableDiv = document.getElementById('scrollableDiv')
    if (scrollableDiv) {
      scrollableDiv.addEventListener(
        'touchmove',
        () => {
          // console.log('++++++', scrollableDiv.scrollTop)
          this.$bus.$emit(BUS.SHOW_TOP_BUTTON, scrollableDiv.scrollTop > window.innerHeight / 2)
        },
        { passive: false }
      )
    }
    this.$bus.$emit(BUS.FULL_SCREEN, false)
    setSEO(currentPage.HOME, this.country)
    this.checkLuckywheel()
    this.checkEnvelop()
    this.checkDailytask()
    this.getFrontTooth()
    this.getNoLogin()
  },
  methods: {
    defaultCurrencyAlias,
    formatMoney,
    ...mapActions(useDailyTaskStore, ['tasklist']),
    ...mapActions(useSystemStore, { ping: 'ping' }),
    ...mapActions(useLobbyStore, {
      updateLobby: 'updateLobby',
      enterGame: 'enterGame',
      getBannersHomeTop: 'getBannersHomeTop'
    }),
    ...mapActions(useUserStore, { updateUserInfo: 'updateUserInfo' }),
    ...mapActions(useEnvelopeStore, { envelope: 'envelope', displayReward: 'displayReward' }),
    getFrontTooth() {
      this.getBannersHomeTop('front_tooth').then((r) => {
        console.log('front_tooth', r)
        this.frontTooth = r.banners
      })
    },
    getNoLogin() {
      this.getBannersHomeTop('nologin').then((r) => {
        console.log('no_login_banner', r)
        this.nologinbanners = r.banners
      })
    },
    onClickBanner(banner) {
      if (banner.cmd === 'no_login_banner') {
        // this.$router.replace(`/${banner.cmdValue}`)
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'no_login_banner', to: POPUP.REGISTER, show: true })
      } else if (banner.cmd == 'game') {
        if (this.isLogin) {
          this.enterGame(parseInt(banner.cmdValue)).then((response) => {
            this.$router.push({ name: 'gameView', params: { currentGameUrl: response.url } })
          })
        } else {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
        }
      } else if (banner && banner.cmd == 'h5') {
        window.location.href = `${banner.cmdValue}?token=${getLocalStorage(Key.Token)}`
      } else if (banner && banner.cmd == 'deeplink') {
        const list = ['vpsExchange', 'luckycashback', 'million', 'dailytask']
        if (list.includes(banner.cmdValue.toLocaleLowerCase())) {
          if (!this.isLogin) {
            this.$bus.$emit(BUS.SHOW_POPUP, { from: 'homeview', to: POPUP.LOGIN, show: true })
            return
          }
        }
        this.$router.replace(`/${banner.cmdValue}`)
      } else if (banner && banner.cmd == 'active') {
        if (banner.cmdValue == 'redenvelope') {
          enterEnvelop(this.isLogin)
        }
      } else if (banner && banner.cmd == 'luckywheel') {
        if (!this.isLogin) {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'banner', to: POPUP.LOGIN, show: true })
          return
        }
        const url = `${banner.cmdValue}?token=${encodeBase64(getLocalStorage(Key.Token))}`
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else if (banner && banner.cmd == 'perksplay') {
        if (!this.isLogin) {
          this.$bus.$emit(BUS.SHOW_POPUP, { from: 'banner', to: POPUP.LOGIN, show: true })
          return
        }
        this.$bus.$emit(BUS.SHOW_POPUP, {
          from: 'homeview',
          to: POPUP.PERKS_PLAY_POPUP,
          show: true
        })
      }
      // console.log('onClickBanner', getFileNameFromUrl(banner.name))
    },
    // enterEnvelope() {
    //   //  红包活动
    //   if (this.isLogin) {
    //     this.envelope().then((res) => {
    //       if (res.id > 0 && res.status < 3) {
    //         //用户身上有红包 直接进入活动页主页
    //         window.location.href = `${window.envelopeUrl}/?active=${getLocalStorage(Key.Token)}&lang=${getLocale()}&cid=hbzz&channel=web`
    //       } else {
    //         //此时用户身上无红包 自动开启红包动画
    //         this.$bus.$emit(BUS.SHOW_ACTIVE_BOX, { hasOpened: false })
    //       }
    //     })
    //   } else {
    //     //弹出活动页注册弹窗
    //     this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.REGISTER, show: true })
    //   }
    // },
    checkEnvelop() {
      if (this.isLogin) {
        this.envelope().then((res) => {
          if (res.id > 0 && res.status < 3) {
            //用户身上有红包 直接进入活动页主页
            this.envelopValue = res.currentReward
            //status 状态 1:收集中，2:收集成功待领取，3:领取成功
            this.envelopColor = res.status == 1 ? '#a40035' : '#009944'
          } else {
            //此时用户身上无红包
            this.displayReward().then((r) => {
              this.envelopValue = r.totalReward
              this.envelopColor = '#a40035'
            })
          }
        })
      } else {
        //此时未登录
        this.displayReward().then((r) => {
          this.envelopValue = r.totalReward == 0 ? '----' : r.totalReward
          this.envelopColor = '#a40035'
        })
      }
    },
    luckywheel() {
      // https://game.megalake.games
      if (this.isLogin) {
        const url =
          `${config.selfDevelopedGameDomain}/luckywheel/index.html?token=` +
          encodeBase64(getLocalStorage(Key.Token))
        this.$router.push({ name: 'gameView', params: { currentGameUrl: url } })
      } else {
        this.$bus.$emit(BUS.SHOW_POPUP, { from: 'gridListGame', to: POPUP.LOGIN, show: true })
      }
    },
    onShowRewardsCenter(type) {
      console.log(type)
      switch (type) {
        case 0:
          // if (this.country == 'ET') {
          //   enterEnvelop(this.isLogin)
          // } else if (this.country == 'KE') {
          // this.$router.replace('/firstRecharge')
          // }
          if (this.country == 'ET') {
            // this.$router.replace('/firstRecharge')
            enterEnvelop(this.isLogin)
          } else if (this.country == 'KE') {
            // this.$router.replace('/cashback')
            if (!this.isLogin) {
              this.$bus.$emit(BUS.SHOW_POPUP, { from: 'HomeView', to: POPUP.LOGIN, show: true })
              return
            }
            this.$router.replace('/luckycashback')
          }
          break
        case 1:
          this.luckywheel()
          break
        default:
          break
      }
    },
    checkLuckywheel() {
      const dev_base_url = 'https://gw.megalake.games/v1/task/spin/num'
      const pro_base_rul = 'https://gw.vivagameclub.com/v1/task/spin/num'
      if (this.isLogin) {
        fetch(ENV == 'production' ? pro_base_rul : dev_base_url, {
          headers: {
            accept: 'application/json, text/plain, */*',
            'cache-control': 'no-cache',
            'content-type': 'application/json;charset=UTF-8',
            pragma: 'no-cache',
            token: getLocalStorage(Key.Token)
          },
          referrer: window.location.hostname,
          referrerPolicy: 'strict-origin-when-cross-origin',
          method: 'POST',
          mode: 'cors',
          credentials: 'omit'
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`)
            }
            return response.json() // 将响应解析为 JSON
          })
          .then((data) => {
            this.showLuckywheelTips = parseInt(data.data.spinNum) > 0
            console.log('spinNum:::====>>>>>', data.data.spinNum)
          }) // 处理成功的响应数据
          .catch((error) => console.error('Fetch error:', error)) // 处理错误;
      }
    },
    checkDailytask() {
      if (!this.isLogin) return
      this.tasklist()
        .then((data) => {
          if (!data) return
          for (const element of data.taskEvery1) {
            if (element.status == 1) {
              this.showLuckywheelTips = true
              return
            }
          }
          for (const element of data.taskEvery2) {
            if (element.status == 1) {
              this.showLuckywheelTips = true
              return
            }
          }
        })
        .catch(() => {
          this.showLuckywheelTips = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.home::-webkit-scrollbar {
  height: 0;
  /* 隐藏滚动条，但保持滚动功能 */
  display: none;
}

.home {
  background: #000;
  width: 100%;
  height: calc(100vh - var(--user-bar-height) - var(--user-bar-height));
  padding-top: var(--user-bar-height);
  padding-bottom: var(--user-bar-height);
  overflow-x: hidden;
  overflow-y: scroll;
  -ms-overflow-style: none;
  /* 隐藏滚动条，但保持滚动功能（仅针对IE和Edge） */

  .padding-top_0 {
    padding-top: var(--page-padding);
  }

  .padding-top_1 {
    padding-top: calc(var(--page-padding) + 5.55vw);
  }

  .padding-top_2 {
    padding-top: calc(var(--page-padding) + var(--user-bar-height) + 5.55vw);
  }

  .banner-content {
    display: flex;
    justify-content: center;

    // padding: var(--page-padding);
    width: 100%;
    // height: 3.25rem;
    overflow: hidden;

    .banners {
      width: 6.8rem;
      // height: 3.25rem;

      .img {
        width: 6.8rem;
        height: 1.8rem;
        border-radius: 0.2rem;
      }

      .join-now-btn {
        position: absolute;
        // margin-left: 0.06rem;
        padding-left: 0.27rem;
        padding-right: 0.32rem;
        height: 0.5rem;
        font-size: 0.24rem;
        line-height: 0.5rem;
        color: #fff;
        text-align: center;
        border-radius: 0.25rem 0 0.25rem 0;
        // margin-right: 0.3rem;
        background: #825c2d;
        background: linear-gradient(145deg, #ceb45f 5%, #825c2d, #ceb45f 50%, #825c2d, #ceb45f 95%);
        background-size: 300% 300%;
        animation: gradientBG 2s linear infinite;
        z-index: 5;
        margin-top: -0.68rem;
        right: 0rem;
      }
    }
  }

  .content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 96%;
    height: auto;
    margin-top: 0;
    margin-right: auto;
    margin-bottom: 0;
    margin-left: auto;
    padding: 0px;
  }

  .index_banner {
    margin: 0.12rem 0;
    padding: 0;
    // height: 1.5rem;
    width: 100%;
    overflow: hidden;
    // margin-top: 0.24rem;
  }

  .sport-iframe {
    width: 100%;
    height: calc(100vh - var(--user-bar-height) - 5.5rem);
  }

  .rewards_enter {
    display: flex;
    justify-content: space-around;
    margin: 0.2rem 0 0.3rem;
    padding: 0 2%;
    height: auto;
    width: 100%;
    overflow: hidden;
    margin-top: 0.24rem;

    .on_left {
      width: 50%;
      // float: left !important;

      .tag {
        font-size: 0.18rem;
        line-height: 0.22rem;
        color: #fff;
        background-color: #009944;
        text-align: center;
        height: auto;
        width: max-content;
        padding-right: 0.1rem;
        padding-left: 0.1rem;
        border-radius: 0 0.1rem 0.1rem 0;
        float: left;
        position: relative;
        z-index: 4;
        display: inline;
        box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.4);
        margin-top: -1.32rem;
        // margin-right: 2.43rem;
        // margin-bottom: -0.24rem;
      }
    }

    .on_right {
      width: 50%;
      // float: right !important;

      .tag {
        font-size: 0.18rem;
        line-height: 0.22rem;
        color: #fff;
        // background-color: #a40035;
        text-align: center;
        height: auto;
        width: max-content;
        padding-right: 0.1rem;
        padding-left: 0.1rem;
        border-radius: 0 0.1rem 0.1rem 0;
        float: left;
        position: relative;
        z-index: 4;
        display: inline;
        box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.4);
        margin-top: -1.32rem;
        // margin-right: 2.43rem;
        // margin-bottom: -0.24rem;
      }
    }

    img {
      width: 90%;
      border-radius: 0.16rem;
    }
  }
}

@keyframes gradientBG {
  0% {
    background-position: 0% 50%;
  }

  100% {
    background-position: 100% 50%;
  }
}
</style>
